<template>
  <div class="UserDashboardTopSectors">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
        <el-card class="box-card expert-card sector-ranking" v-loading="is_sector_list_loading"
          id="user_dashboard_top_sector">
          <div class="flex flex-space-between label-md-bold-black stock-ranking capitalize" style="padding: 0 15px;">
            <div class="flex">
              <img src="../assets/images/rank0.png" style="height: 18px; margin-right: 10px;" />
              <!-- {{ userProfile.first_name ? userProfile.first_name+"'s" : '' }} Rank Board -->
              My Portfolio

              <!-- <div class="download-btn left-margin-15" v-if="top_sector_list.length" @click="downloadRankBoardInCSV()">
                DOWNLOAD CSV
              </div> -->

              <RankBoardExplanatory></RankBoardExplanatory>
            </div>

            <!-- <div class="flex">
              <div class="period-btn-mini" @click="selectPeriod('1M')"
                :class="[active_period == '1M' ? 'active-period-btn-mini' : '']">1M</div>
              <div class="period-btn-mini" @click="selectPeriod('3M')"
                :class="[active_period == '3M' ? 'active-period-btn-mini' : '']">3M</div>
              <div class="period-btn-mini" @click="selectPeriod('6M')"
                :class="[active_period == '6M' ? 'active-period-btn-mini' : '']">6M</div>
              <div class="period-btn-mini" @click="selectPeriod('1Y')"
                :class="[active_period == '1Y' ? 'active-period-btn-mini' : '']">1Y</div>
              <div class="period-btn-mini" @click="selectPeriod('MAX')"
                :class="[active_period == 'MAX' ? 'active-period-btn-mini' : '']">MAX</div>
            </div> -->
          </div>


          <!-- do not remove this white background color,,,added style here to get white background for downloaded image -->
          <!-- <div id="user_dashboard_top_sector" style="background-color: #fff;"> -->
          <table class="rank-board-table top-margin-10">
            <thead>
              <tr>
                <th>&nbsp;</th>
                <!-- <th>&nbsp;</th> -->
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th>&nbsp;</th>
                <th colspan="2">Reco</th>
              </tr>
              <tr>
                <th style="min-width: 8px;">Ranking</th>

                <th>Name</th>

                <!-- <th :style="{ 'color': active_sector_ranking_sorting == 'rating' ? '#3f67f2' : '' }">

                  <el-popover
                    placement="top"
                    title="Ranking based on rating"
                    width="320"
                    trigger="hover"
                    content="Star Rating based on Annualise ROI in decile format.">
                    <div slot="reference" class="cursor-pointer inline-block" @click="sortTopSectorTableByHeading('rating')">
                      Rating
                      <i class="el-icon-top" v-if="active_sector_ranking_sorting == 'rating'"></i>
                    </div>
                  </el-popover>

                </th> -->

                <th style="min-width: 50px;"
                  :style="{ 'color': active_sector_ranking_sorting == 'absolute_roi' ? '#3f67f2' : '' }">

                  <!-- <el-popover
                    placement="top"
                    title="Ranking based on Absolute ROI"
                    width="320"
                    trigger="hover"
                    content="">
                  </el-popover> -->
                  <div class="cursor-pointer" @click="sortTopSectorTableByHeading('absolute_roi')">
                    Avg ROI
                    <i class="el-icon-top" v-if="active_sector_ranking_sorting == 'absolute_roi'"></i>
                  </div>

                </th>

                <!-- <th style="min-width: 80px;" :style="{ 'color': active_sector_ranking_sorting == 'accuracy' ? '#3f67f2' : '' }">

                  <el-popover
                    placement="top"
                    title="Ranking based on accuracy"
                    width="320"
                    trigger="hover"
                    content="Accuracy after adjusting error rate and updated price estimates.">
                  </el-popover>

                  <div slot="reference" class="cursor-pointer inline-block" @click="sortTopSectorTableByHeading('accuracy')">
                    Accuracy
                    <i class="el-icon-top" v-if="active_sector_ranking_sorting == 'accuracy'"></i>
                  </div>

                </th> -->

                <th style="min-width: 110px;"
                  :style="{ 'color': active_sector_ranking_sorting == 'success_rate' ? '#3f67f2' : '' }">

                  <!-- <el-popover
                    placement="top"
                    title="Ranking based on success rate"
                    width="320"
                    trigger="hover"
                    content="Success Rate is based on No. of target achieved / No. total recommendations.">
                  </el-popover> -->

                  <div class="cursor-pointer inline-block" @click="sortTopSectorTableByHeading('success_rate')">
                    Success Rate
                    <i class="el-icon-top" v-if="active_sector_ranking_sorting == 'success_rate'"></i>
                  </div>

                </th>

                <th style="min-width: 50px;"
                  :style="{ 'color': active_sector_ranking_sorting == 'live_reco' ? '#3f67f2' : '' }">

                  <!-- <el-popover
                    placement="top"
                    title="Ranking based on Live reco"
                    width="200"
                    trigger="hover"
                    content="Descending order.">
                  </el-popover> -->

                  <div class="cursor-pointer" @click="sortTopSectorTableByHeading('live_reco')">
                    Live
                    <i class="el-icon-top" v-if="active_sector_ranking_sorting == 'live_reco'"></i>
                  </div>

                </th>

                <th style="min-width: 50px;"
                  :style="{ 'color': active_sector_ranking_sorting == 'total_reco' ? '#3f67f2' : '' }">

                  <!-- <el-popover
                    placement="top"
                    title="Ranking based on Total reco"
                    width="200"
                    trigger="hover"
                    content="Descending order.">
                  </el-popover> -->

                  <div class="cursor-pointer" @click="sortTopSectorTableByHeading('total_reco')">
                    Total
                    <i class="el-icon-top" v-if="active_sector_ranking_sorting == 'total_reco'"></i>
                  </div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(sector, index) in top_sector_list" :key="index" @click="selectSector(index, sector)"
                :class="{ 'selected-row': selected_sector_index == index }">
                <td>
                  <Hexagon :rank="sector.rank"></Hexagon>
                </td>

                <td class="border-right-gray capitalize" style="text-align: left; font-size: 0.7rem;">
                  <div>{{ sector.name }}</div>
                </td>

                <td class="border-right-gray">{{ sector.absolute_roi ? sector.absolute_roi.toFixed(2) + '%' : '-' }}</td>

                <!-- <td class="border-right-gray">{{ sector.accuracy ? sector.accuracy.toFixed(2) + '%' : '-' }}</td> -->

                <td class="border-right-gray">{{ sector.success_rate ? sector.success_rate.toFixed(2) + '%' : '-' }}</td>

                <td class="primary-theme-color">{{ sector.live_reco }}</td>

                <td>{{ sector.total_reco }}</td>
              </tr>
            </tbody>
          </table>
          <!-- </div> -->

          <el-pagination class="label-xs-bold text-center top-margin-10"
            v-if="top_sector_list.length && sector_rank_board_number_of_pages > 1" small
            :current-page.sync="sector_rank_board_page_no" @current-change="handleSectorRankBoardCurrentPageChange"
            :page-size="sector_rank_board_entries_per_page" layout="prev, pager, next"
            :total="sector_rank_board_total_entries">
          </el-pagination>
          <!-- :pager-count="11" -->

          <!-- if no top experts found then displayed no data -->
          <NoDataFound v-if="!top_sector_list.length && !is_sector_list_loading"></NoDataFound>
        </el-card>
      </el-col>

      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">

        <div class="selected-filter-section">
          <div class="label-xs-bold">FILTERS:</div>
          <div style="display: flex; flex-wrap: wrap; margin: 0 5px">
            <div v-if="filterObj.filters && filterObj.filters.length" class="filters-content"
              v-for="(filter, filter_index) in filterObj.filters" :key="filter_index">
              {{ filter }}
            </div>
            <div class="filters-content" v-if="filterObj.sector">
              Sector
            </div>
            <div class="filters-content"
              v-if="Object.keys(filterObj.target_period).length && filterObj.target_period.key != 'Long_term'">
              {{ filterObj.target_period.key }}
            </div>
            <div class="filters-content" v-if="filterObj.term">
              {{ filterObj.term }}
            </div>
          </div>
        </div>

        <el-card class="stock-detail-card" v-if="top_sector_list.length" id="user_dashboard_top_sector_falsh_card"
          v-loading="is_flash_card_details_loading">
          <div class="stock-base-details">
            <div class="flex-space-between" style="flex-wrap: wrap;">
              <div class="stock-base-header">
                <Hexagon class="right-margin-10" :rank="stock_details.data.rank"></Hexagon>
                <div>
                  <div class="label-md-bold-black ellipsis cursor-pointer capitalize"
                    style="font-size: 13px; max-width: 160px;"
                    :title="stock_details.data.name ? stock_details.data.name : ''"
                    @click="goToPastRecoPage(stock_details.data.name)">
                    {{ stock_details.data.name }}
                  </div>
                </div>

                <!-- <div class="download-btn" style="margin-left: auto;" v-if="stock_details.experts.length" @click="downloadFlashCardDetailsInCSV()">
                  DOWNLOAD CSV
                </div> -->
              </div>
            </div>

            <!-- <div class="flex-space-between top-margin-5" style="margin-left: 30px;">
              <el-tag
                v-if="stock_details.data.stock_sector"
                size="mini"
                class="sector-tag ellipsis"
                :title="stock_details.data.stock_sector"
                effect="plain"
                type="info"
                style="background: #eff5fe; height: 16px; line-height: 15px; font-size: 8px;"
              >{{ stock_details.data.stock_sector }}
              </el-tag>
            </div> -->

            <div class="flex-space-between top-margin-15">
              <div>
                <span class="label-md-bold-black">{{ stock_details.data.absolute_roi ?
                  stock_details.data.absolute_roi.toFixed(2) + '%' : '-' }}</span>
                <!-- <span class="label-md-bold-black" style="font-size: 10px;"> {{ getYearStringFromNumberOfDays(stock_details.data.performance_period_in_days_sum) }} </span> -->
                <div class="input-label-gray">Avg ROI</div>
              </div>

              <!-- <div>
                <span class="label-md-bold-black">{{  stock_details.data.annual_roi ? stock_details.data.annual_roi + '%' : '-' }}</span>
                <div class="input-label-gray">Annualised ROI</div>
              </div> -->

              <div>&nbsp;</div>
              <div>&nbsp;&nbsp;&nbsp;</div>
            </div>

            <div class="flex-space-between top-margin-15">
              <!-- <div>
                <span class="label-md-bold-black">{{ stock_details.data.accuracy ? stock_details.data.accuracy.toFixed(2) + '%' : '-' }}</span>
                <div class="input-label-gray">Accuracy</div>
              </div> -->

              <div>
                <span class="label-md-bold-black">{{ stock_details.data.success_rate ?
                  stock_details.data.success_rate.toFixed(2) + '%' : '-' }}</span>
                <div class="input-label-gray">Success Rate</div>
              </div>

              <div>
                <div class="text-center">
                  <span class="primary-theme-color font-06rem" title="Live recommendations">Live </span>
                  <span class="primary-theme-color font-08rem">{{ stock_details.data.live_reco }}</span> &nbsp;

                  <span class="font-06rem" title="Total recommendations">Total </span>
                  <span class="font-08rem">{{ stock_details.data.total_reco }}</span>
                  <div class="input-label-gray" style="font-size: 10px;">Recommendations</div>
                </div>
              </div>
            </div>

            <!-- <div class="flex-space-between top-margin-15">
              <div>
                <span class="label-md-bold-black"><i class="el-icon-star-on" style="color: #f7ba2a;"></i> {{ stock_details.data.performer_rating ? stock_details.data.performer_rating : '-' }}/5</span>
                <div class="input-label-gray">Performer Rating</div>
              </div>

              <div>
                <span class="label-md-bold-black"><i class="el-icon-star-on" style="color: #33bb6d;"></i> {{ stock_details.data.overall_rating ? stock_details.data.overall_rating : '-' }}/5</span>
                <div class="input-label-gray">My Portfolio Rating</div>
              </div>

              <div>&nbsp;</div>
              <div>&nbsp;&nbsp;&nbsp;</div>
            </div> -->
          </div>

          <div class="stock-accuracy-detail-wrapper" v-loading="is_stocks_details_experts_list_loading">

            <el-select v-if="top_sector_list.length" v-model="expert_details_category" placeholder="Select" size="mini"
              class="mini-select" @change="changeExpertDetailsCategoryDropdown()" style="width: 80%;">
              <el-option v-for="(category, category_index) in expert_details_category_list" :key="category_index"
                :label="category.lable" :value="category.value"></el-option>
            </el-select>

            <div v-if="stock_details.experts.length">
              <table>
                <thead>
                  <tr>
                    <th>
                      Expert Name
                    </th>

                    <th v-if="expert_details_category == 'accuracy'">Accuracy</th>
                    <th v-if="expert_details_category == 'rating'">Rating</th>
                    <th v-if="expert_details_category == 'absolute_roi'">ROI</th>
                    <th v-if="expert_details_category == 'success_rate'">Success Rate</th>
                    <th v-if="(expert_details_category == 'total_reco' || expert_details_category == 'live_reco')">LR/TR
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, index) in stock_details.experts" :key="index">
                    <td style="width: 90px;">
                      <span class="label-md-black" style="font-size: 0.8rem;"
                        @click="redirectExpertToPastRecoPage(item)">{{ item.full_name }}</span>
                      <div>
                        <span class="input-label-gray">{{ item.profession }}</span>
                      </div>
                    </td>

                    <td style="width: 90px;" class="label-xss-black" v-if="expert_details_category == 'accuracy'">
                      {{ item.accuracy ? item.accuracy.toFixed(2) + '%' : '-' }}

                      <div v-if="item.total_result">
                        (Total Results - {{ item.total_result }})
                      </div>
                    </td>

                    <td style="width: 90px;" class="label-xss-black" v-if="expert_details_category == 'success_rate'">
                      {{ item.success_rate ? item.success_rate.toFixed(2) + '%' : '-' }}
                    </td>

                    <td style="width: 90px;" class="label-xss-black" v-if="expert_details_category == 'absolute_roi'">
                      {{ item.absolute_roi ? item.absolute_roi.toFixed(2) + '%' : '-' }}
                    </td>

                    <!-- <td style="width: 90px;" class="label-xss-black" v-if="expert_details_category == 'rating'">
                      <span><i class="el-icon-star-on" style="color: #f7ba2a;"></i></span>  {{ item.overall_rating }} / 5
                    </td> -->

                    <td style="width: 90px;" class="label-xss-black"
                      v-if="(expert_details_category == 'total_reco' || expert_details_category == 'live_reco')">
                      <div class="flex flex-center">
                        <div class="flex flex-space-between">
                          <div class="primary-theme-color right-margin-20">{{ item.live_reco }}</div>
                          <div>{{ item.total_reco }}</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <el-pagination class="label-xs-bold text-center top-margin-10" v-if="stock_details_total_entries > 3" small
                :current-page.sync="stock_details_stock_rank_board_page_no"
                @current-change="handleStockDetailsCurrentPageChange" :page-size="stock_details_entries_per_page"
                layout="prev, pager, next" :total="stock_details_total_entries">
              </el-pagination>
            </div>

            <!-- if no stocks found then displayed no data -->
            <div class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20"
              v-if="!is_stocks_details_experts_list_loading && !stock_details.experts.length">
              No data available
            </div>

          </div>
        </el-card>

      </el-col>
    </el-row>

    <!-- portfolio overview, accuracy and success rate graph section -->
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-card class="box-card chart-card relative">
          <div class="label-md-bold-black flex">
            <img src="../assets/images/asset1.png" style="height: 19px; margin-right: 10px;" />
            Avg ROI
          </div>

          <div class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
            v-if="!is_portfolio_graph_data_available" style="top: 100px!important; left: 0; right: 0;">
            No data available
          </div>

          <div v-if="is_portfolio_graph_data_available">
            <div class="graph-container">
              <div ref="portfolio_overview_graph" style="width: 100%; height: 285px;"></div>
            </div>

            <!-- legends section -->
            <div>
              <div style="padding: 0 0 5px 0;">
                <div class="flex-space-between">
                  <div style="width: 40%;">&nbsp;</div>
                  <div class="font-07rem font-weight-600 text-center" style="width: 30%;">Avg ROI</div>
                  <div class="font-07rem font-weight-600 text-center" style="width: 30%;">Weightage</div>
                </div>

                <div class="flex-space-between top-margin-10 bottom-margin-5"
                  v-for="(item, item_index) in portfolio_overview_series[0].data" :key="item_index">
                  <div class="flex cursor-pointer legend" style="width: 40%;"
                    @mouseover="highlightPortfolioChart(item, item_index, 0)" @mouseout="downPortfolioChart(item)">
                    <div class="pie-chart-legends right-margin-10" :style="{ background: item.itemStyle.color }"></div>
                    <div class="font-07rem"
                      :style="active_portfolio_inner_chart_legend == item.name ? { fontWeight: 600 } : {}">{{ item.name }}
                    </div>
                  </div>

                  <div class="font-07rem text-center" style="width: 30%;">
                    {{ item.meta_data && item.meta_data.absolute_roi ? item.meta_data.absolute_roi + '%' : '-' }}
                  </div>

                  <div class="font-07rem text-center" style="width: 30%;">{{ item.value ? item.value + '%' : '-' }}</div>
                </div>
              </div>

              <div class="legends-scroll-bar" id="portfolio-chart-legends"
                style="border-top: 1px solid #ddd; padding: 0 0 5px 0; height: 100px; overflow-y: auto;">
                <div class="flex-space-between top-margin-10"
                  v-for="(item, item_index) in portfolio_overview_series[1].data" :key="item_index">
                  <div :id="+'_' + item.name + '_portfolio'" style="width: 40%;" class="legend flex cursor-pointer"
                    @mouseover="highlightPortfolioChart(item, item_index, 1)" @mouseout="downPortfolioChart(item)">
                    <div class="pie-chart-legends right-margin-10" :style="{ background: item.itemStyle.color }"></div>
                    <div class="font-07rem ellipsis" style="width: 150px;" :title="item.name"
                      :style="active_portfolio_outer_chart_legend == item.name ? { fontWeight: 600 } : {}">{{ item.name }}
                    </div>
                  </div>

                  <div class="font-07rem text-center" style="width: 30%;">{{ item.meta_data && item.meta_data.absolute_roi
                    ? item.meta_data.absolute_roi + '%' : '-' }}</div>

                  <div class="font-07rem text-center" style="width: 30%;">{{ item.value ? item.value + '%' : '-' }}</div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- accuracy chart -->
      <!-- <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
        <el-card class="box-card chart-card relative">
          <div class="flex-space-between">
            <div class="label-md-bold-black flex">
              <img src="../assets/images/asset1.png" style="height: 19px; margin-right: 10px;" />
              Accuracy
            </div>
          </div>

          <div class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute" v-if="!is_accuracy_graph_data_available" style="top: 100px!important; left: 0; right: 0;">
            No data available
          </div>

          <div v-if="is_accuracy_graph_data_available">
            <div class="graph-container">
              <div ref="accuracy_graph" style="width: 100%; height: 285px;"></div>
            </div>

            legends section
            <div>
              <div style="padding: 0 0 5px 0;">
                <div class="flex-space-between">
                  <div>&nbsp;</div>
                  <div class="font-07rem font-weight-600">Accuracy</div>
                </div>

                <div class="flex-space-between top-margin-10 bottom-margin-5" v-for="(item, item_index) in accuracy_pie_chart_series[0].data" :key="item_index">
                    <div class="flex cursor-pointer legend" @mouseover="highlightAccuracyChart(item, item_index, 0)" @mouseout="downAccuracyChart(item)">
                      <div class="pie-chart-legends right-margin-10" :style="{ background : item.itemStyle.color }"></div>
                      <div class="font-07rem" :style="active_accuracy_inner_chart_legend == item.name ? { fontWeight: 600 } : {}">{{ item.name }}</div>
                    </div>

                    <div class="font-07rem">{{ item.value ? item.value + '%' : '-' }}</div>
                </div>
              </div>

              <div class="legends-scroll-bar" id="accuracy-chart-legends" style="border-top: 1px solid #ddd; padding: 0 0 5px 0; height: 100px; overflow-y: auto;">
                <div class="flex-space-between top-margin-10" v-for="(item, item_index) in accuracy_pie_chart_series[1].data" :key="item_index">
                  <div :id="+'_'+item.name+'_accuracy'" class="legend flex cursor-pointer" @mouseover="highlightAccuracyChart(item, item_index, 1)" @mouseout="downAccuracyChart(item)">
                    <div class="pie-chart-legends right-margin-10" :style="{ background : item.itemStyle.color }"></div>
                    <div class="font-07rem ellipsis" style="width: 150px;" :title="item.name" :style="active_accuracy_outer_chart_legend == item.name ? { fontWeight: 600 } : {}">{{ item.name }}</div>
                  </div>

                  <div class="font-07rem">{{ item.value ? item.value + '%' : '-' }}</div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col> -->

      <!-- success rate chart -->
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-card class="box-card chart-card relative">
          <div class="flex label-md-bold-black">
            <img src="../assets/images/asset3.png" style="height: 19px; margin-right: 10px;" />
            Success Rate
          </div>

          <div class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
            v-if="!is_success_rate_graph_data_available" style="top: 100px!important; left: 0; right: 0;">
            No data available
          </div>

          <div v-if="is_success_rate_graph_data_available">
            <div class="graph-container">
              <div ref="success_rate_graph" style="width: 100%; height: 285px;"></div>
            </div>

            <!-- legends section -->
            <div>
              <div style="padding: 0 0 5px 0;">
                <div class="flex-space-between">
                  <div>&nbsp;</div>
                  <div class="font-07rem font-weight-600">Success Rate</div>
                </div>

                <div class="flex-space-between top-margin-10 bottom-margin-5"
                  v-for="(item, item_index) in success_rate_pie_chart_series[0].data" :key="item_index">
                  <div class="flex cursor-pointer legend" @mouseover="highlightSuccessRateChart(item, item_index, 0)"
                    @mouseout="downSuccessRateChart(item)">
                    <div class="pie-chart-legends right-margin-10" :style="{ background: item.itemStyle.color }"></div>
                    <div class="font-07rem"
                      :style="active_success_rate_inner_chart_legend == item.name ? { fontWeight: 600 } : {}">{{ item.name
                      }}</div>
                  </div>

                  <div class="font-07rem">{{ item.value ? item.value + '%' : '-' }}</div>
                </div>
              </div>

              <div class="legends-scroll-bar" id="success-rate-chart-legends"
                style="border-top: 1px solid #ddd; padding: 0 0 5px 0; height: 100px; overflow-y: auto;">
                <div class="flex-space-between top-margin-10"
                  v-for="(item, item_index) in success_rate_pie_chart_series[1].data" :key="item_index">
                  <div :id="+'_' + item.name + '_success_rate'" class="legend flex cursor-pointer"
                    @mouseover="highlightSuccessRateChart(item, item_index, 1)" @mouseout="downSuccessRateChart(item)">
                    <div class="pie-chart-legends right-margin-10" :style="{ background: item.itemStyle.color }"></div>
                    <div class="font-07rem ellipsis" style="width: 150px;" :title="item.name"
                      :style="active_success_rate_outer_chart_legend == item.name ? { fontWeight: 600 } : {}">{{ item.name
                      }}</div>
                  </div>

                  <div class="font-07rem">{{ item.value ? item.value + '%' : '-' }}</div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- reco status graph section -->
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-card class="box-card relative">
          <div class="label-md-bold-black flex">
            <img src="../assets/images/asset1.png" style="height: 19px; margin-right: 10px;" />
            Reco Status
          </div>

          <div class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20"
            v-if="!is_reco_status_data_available">
            No data available
          </div>

          <div class="flex-space-between flex-wrap" v-if="is_reco_status_data_available">
            <div class="graph-container">
              <div ref="reco_status_graph" style="width: 285px; height: 285px;"></div>
            </div>

            <!-- legends section -->
            <div class="top-margin-10">
              <div>
                <div class="label-md-bold-black">{{ total_reco ? total_reco : 0 }}</div>
                <div class="label-xs-bold">Total Reco</div>
              </div>

              <div class="flex-space-between top-margin-10 bottom-margin-5"
                v-for="(item, item_index) in reco_status_pie_chart_series[0].data" :key="item_index">
                <div class="flex cursor-pointer legend" v-if="item.value"
                  @mouseover="highlightRecoStatusChart(item, item_index)" @mouseout="downRecoStatusChart(item)">
                  <div class="pie-chart-legends right-margin-10" :style="{ background: item.itemStyle.color }"></div>
                  <div class="font-07rem"
                    :style="active_reco_status_chart_legend == item.name ? { fontWeight: 600 } : {}">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-card class="box-card relative">
          <div class="flex-space-between">
            <div class="label-md-bold-black flex">
              <img src="../assets/images/asset1.png" style="height: 19px; margin-right: 10px;" />
              Portfolio Overview
            </div>
          </div>

          <div class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20"
            v-if="!is_reco_count_data_available">
            No data available
          </div>

          <div class="flex-space-between flex-wrap" v-if="is_reco_count_data_available">
            <div class="graph-container">
              <div ref="reco_count_graph" style="width: 285px; height: 285px;"></div>
            </div>

            <div>
              <div class="flex-space-between top-margin-10 bottom-margin-5"
                v-for="(item, item_index) in reco_count_series[0].data" :key="item_index">
                <div class="flex cursor-pointer legend" @mouseover="highlightRecoCountChart(item, item_index)"
                  @mouseout="downRecoCountChart(item)">
                  <div class="pie-chart-legends right-margin-10" :style="{ background: item.itemStyle.color }"></div>
                  <div class="font-07rem" :style="active_reco_count_chart_legend == item.name ? { fontWeight: 600 } : {}">
                    {{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { HelperNetworkCallBack } from "../mixins/Helper";
var echarts = require("echarts");
import NoDataFound from "@/components/NoDataFound.vue";
import Hexagon from "@/components/Hexagon.vue";
import RankBoardExplanatory from "@/components/RankBoardExplanatory.vue";
import { graphData } from "../mixins/BarGraphData";
import { serverAddr, serverHostName, serverAddrForCSV } from "../networkConfig";
import { filterCallBack } from "../mixins/filter";
import { EventBus } from "../eventBus";
import { screenSize } from "../mixins/ScreenSize.js";
import domtoimage from 'dom-to-image';

export default {
  name: 'UserDashboardTopSectors',

  components: {
    NoDataFound,
    Hexagon,
    RankBoardExplanatory
  },

  mixins: [graphData, filterCallBack, HelperNetworkCallBack, screenSize],

  props: ['active_period'],

  data() {
    return {
      active_sector_ranking_sorting: 'absolute_roi',

      top_sector_list: [],

      filter_list: [
        {
          title: "Sectors"
        },
        {
          title: "Market cap",
          filter: ["Large Cap", "Mid Cap", "Small Cap"]
        },
        {
          title: "Reco type",
          filter: ["Buy", "Sell"]
        },
        {
          title: "Term"
        },
        {
          title: "Target period"
        },
      ],

      stock_details: {
        data: {},
        experts: []
      },

      filterObj: {
        filters: [],
        sector: "",
        term: "",
        target_period: {},
        selected_filters_title: []
      },

      badge_profile: {
        rank: '',
        total_expert_count: ''
      },

      ranking_board_sector_name_list: [],

      is_sector_list_loading: false,
      is_stocks_details_experts_list_loading: false,
      is_profile_data_loading: false,
      is_flash_card_details_loading: false,

      selected_sector_index: 0,

      selected_filters: [],

      sector_rank_board_page_no: 1,
      sector_rank_board_number_of_pages: null,
      sector_rank_board_entries_per_page: 5,
      sector_rank_board_total_entries: null,

      expert_details_category: 'absolute_roi',
      expert_details_category_list: [
        // {
        //   lable: 'Based on overall Rating',
        //   value: 'rating'
        // },
        {
          lable: 'Based on ROI',
          value: 'absolute_roi'
        },
        // {
        //   lable: 'Based on Accuracy',
        //   value: 'accuracy'
        // },
        {
          lable: 'Based on Success Rate',
          value: 'success_rate'
        },
        {
          lable: 'Based on live Recommendation',
          value: 'live_reco'
        },
        {
          lable: 'Based on total Recommendation',
          value: 'total_reco'
        }
      ],

      stock_details_stock_rank_board_page_no: 1,
      stock_details_stock_rank_board_number_of_pages: null,
      stock_details_entries_per_page: 3,
      stock_details_total_entries: null,

      accuracy_graph_instance: null,
      success_rate_graph_instance: null,
      sector_results_graph_instance: null,
      max_reco_graph_instance: null,

      // is_max_reco_graph_data_available: true,
      is_portfolio_graph_data_available: true,
      is_accuracy_graph_data_available: true,
      is_success_rate_graph_data_available: true,
      is_stock_results_graph_data_available: true,
      is_reco_status_data_available: true,
      is_reco_count_data_available: true,

      total_reco: '',
      active_reco_status_chart_legend: '',
      active_reco_count_chart_legend: '',
      active_accuracy_inner_chart_legend: '',
      active_accuracy_outer_chart_legend: '',
      active_success_rate_inner_chart_legend: '',
      active_success_rate_outer_chart_legend: '',
      active_portfolio_inner_chart_legend: '',
      active_portfolio_outer_chart_legend: '',
    }
  },

  watch: {
    active_period() {
      this.getStockAntsTopSectorList();
    },
  },

  mounted() {
    // emitted filter list from here to HomePageSideBar.vue
    this.$emit('filters', this.filter_list);

    EventBus.$on("emitSelectedFilters", filterObj => {
      this.filterObj = JSON.parse(JSON.stringify(filterObj));

      this.sector_rank_board_page_no = 1; //reset page no to 1
      this.stock_details_stock_rank_board_page_no = 1;
      this.active_period = '1M';

      this.getStockAntsTopSectorList();    //get top sector ranking api called
    });

    this.initGraphInstance();

    this.getStockAntsTopSectorList();    //get top sector ranking api called

    setTimeout(() => {
      this.getProtfolioGraphData();
      // this.getAccuracyGraphData();
      this.getSuccessRateGraphData();
      this.getRecommendationOverview();
      this.getRecommendationCount();
    }, 500);
  },

  methods: {
    selectPeriod(period) {
      if (period == '1M') {
        this.active_period = '1M';
      } else if (period == '3M') {
        this.active_period = '3M';
      } else if (period == '6M') {
        this.active_period = '6M';
      } else if (period == '1Y') {
        this.active_period = '1Y';
      } else if (period == 'MAX') {
        this.active_period = 'MAX';
      }

      this.filterObj.target_period = {};

      this.is_portfolio_graph_data_available = true;
      this.is_accuracy_graph_data_available = true;
      this.is_success_rate_graph_data_available = true;
      this.is_reco_status_data_available = true;
      this.is_reco_count_data_available = true;

      this.getStockAntsTopSectorList();

      setTimeout(() => {
        // reinit chart instances
        this.initGraphInstance();

        this.getProtfolioGraphData();
        this.getAccuracyGraphData();
        this.getSuccessRateGraphData();
        this.getRecommendationOverview();
        this.getRecommendationCount();
      }, 500);
    },

    // for reco status chart
    highlightRecoStatusChart(params, index) {
      this.reco_status_graph_instance.dispatchAction({
        type: 'showTip',
        batch: [
          {
            seriesIndex: 0,
            dataIndex: index
          }
        ]
      });

      this.reco_status_graph_instance.dispatchAction({
        type: 'highlight',
        seriesIndex: 0,
        dataIndex: index
      });
    },

    downRecoStatusChart(params) {
      this.reco_status_graph_instance.dispatchAction({
        type: 'hideTip',
      });

      this.reco_status_graph_instance.dispatchAction({
        type: 'downplay',
        // seriesIndex: index,
      });
    },

    // for reco count chart
    highlightRecoCountChart(params, index) {
      this.reco_count_graph_instance.dispatchAction({
        type: 'showTip',
        batch: [
          {
            seriesIndex: 0,
            dataIndex: index
          }
        ]
      });

      this.reco_count_graph_instance.dispatchAction({
        type: 'highlight',
        seriesIndex: 0,
        dataIndex: index
      });
    },

    downRecoCountChart(params) {
      this.reco_count_graph_instance.dispatchAction({
        type: 'hideTip',
      });

      this.reco_count_graph_instance.dispatchAction({
        type: 'downplay',
        // seriesIndex: index,
      });
    },

    // for protfolio chart
    highlightPortfolioChart(params, index, series_index) {
      this.portfolio_overview_graph_instance.dispatchAction({
        type: 'showTip',
        batch: [
          {
            seriesIndex: series_index,
            dataIndex: index
          }
        ]
      });

      this.portfolio_overview_graph_instance.dispatchAction({
        type: 'highlight',
        seriesIndex: series_index,
        dataIndex: index
      });
    },

    downPortfolioChart(params) {
      this.portfolio_overview_graph_instance.dispatchAction({
        type: 'hideTip',
      });

      this.portfolio_overview_graph_instance.dispatchAction({
        type: 'downplay',
        // seriesIndex: index,
      });
    },

    // for accuracy chart
    highlightAccuracyChart(params, index, series_index) {
      // this.accuracy_graph_instance.dispatchAction({
      //   type: 'showTip',
      //   batch: [
      //     {
      //       seriesIndex: series_index,
      //       dataIndex: index
      //     }
      //   ]
      // });

      // this.accuracy_graph_instance.dispatchAction({
      //   type: 'highlight',
      //   seriesIndex: series_index,
      //   dataIndex: index
      // });
    },

    downAccuracyChart(params) {
      // this.accuracy_graph_instance.dispatchAction({
      //   type: 'hideTip',
      // });

      // this.accuracy_graph_instance.dispatchAction({
      //   type: 'downplay',
      //   // seriesIndex: index,
      // });
    },

    // for success rate chart
    highlightSuccessRateChart(params, index, series_index) {
      this.success_rate_graph_instance.dispatchAction({
        type: 'showTip',
        batch: [
          {
            seriesIndex: series_index,
            dataIndex: index
          }
        ]
      });

      this.success_rate_graph_instance.dispatchAction({
        type: 'highlight',
        seriesIndex: series_index,
        dataIndex: index
      });
    },

    downSuccessRateChart(params) {
      this.success_rate_graph_instance.dispatchAction({
        type: 'hideTip',
      });

      this.success_rate_graph_instance.dispatchAction({
        type: 'downplay',
        // seriesIndex: index,
      });
    },


    //function to redirect on user's past reco track page
    //passed sector name as a param
    goToPastRecoPage(name) {
      this.$router.push({ name: "pastRecommendations", query: { sector: name } });
    },

    //function to redirect on other expert past reco track page
    redirectExpertToPastRecoPage(expert) {
      if (expert.id == this.userProfile.id) {
        this.$router.push({ name: "pastRecommendations" });
      } else {
        this.$router.push({ name: "expertsPastRecommendations", query: { user_id: expert.id, user: expert.response_type } });
      }
    },

    // calls when clicked on sector ranking boards table header
    sortTopSectorTableByHeading(heading) {
      if (heading == 'rating') {
        this.active_sector_ranking_sorting = heading;
      } else if (heading == 'absolute_roi') {
        this.active_sector_ranking_sorting = heading;
      } else if (heading == 'accuracy') {
        this.active_sector_ranking_sorting = heading;
      } else if (heading == 'success_rate') {
        this.active_sector_ranking_sorting = heading;
      } else if (heading == 'total_reco') {
        this.active_sector_ranking_sorting = heading;
      } else if (heading == 'live_reco') {
        this.active_sector_ranking_sorting = heading;
      }

      this.sector_rank_board_page_no = 1;     //reset page no to 1
      this.stock_details_stock_rank_board_page_no = 1;

      this.expert_details_category = heading;

      this.getStockAntsTopSectorList();
    },

    handleSectorRankBoardCurrentPageChange(val) {
      this.sector_rank_board_page_no = val;
      this.stock_details_stock_rank_board_page_no = 1;

      this.getStockAntsTopSectorList();
    },

    selectSector(index, item) {
      this.selected_sector_index = index;      //changed selected stocks row index

      this.stock_details.data = {};
      this.stock_details.data = JSON.parse(JSON.stringify(item));

      this.is_stocks_details_experts_list_loading = true; //enabled loader

      this.stock_details_stock_rank_board_page_no = 1;     //set page no to 1

      // reset dropdowns on selecting stock from rankboard
      this.expert_details_category = this.active_sector_ranking_sorting;

      this.getExpertsListRecommendedForSelectedSector(); //called api to get selected experts stocks
    },

    changeExpertDetailsCategoryDropdown(index, item) {
      this.is_stocks_details_experts_list_loading = true; //enabled loader

      this.stock_details_stock_rank_board_page_no = 1;     //set page no to 1

      this.getExpertsListRecommendedForSelectedSector(); //called api to get selected experts stocks
    },

    //api called to get top sectors
    getStockAntsTopSectorList() {
      this.is_sector_list_loading = true; //enabled loader
      this.is_stocks_details_experts_list_loading = true; //enabled loader

      serverAddr
        .post("/my_dashboard/v1/sector/ranking_board/", {
          user_id: this.userProfile.id,
          page_number: this.sector_rank_board_page_no,
          page_per_entries: this.sector_rank_board_entries_per_page,
          duration: this.filterObj.target_period.key
            ? []
            : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
          ranking_by: this.active_sector_ranking_sorting,
          sector_list: this.filterObj.sector ? [this.filterObj.sector] : [],
          filters: this.filterObj.filters,
          target_period: Object.keys(this.filterObj.target_period).length ? this.filterObj.target_period : {},
          period: !Object.keys(this.filterObj.target_period).length ? this.active_period : ''
        })
        .then(response => {
          if (response.data.status) {
            this.top_sector_list = response.data.data;

            this.selected_sector_index = 0;

            if (this.top_sector_list.length) {
              let item = JSON.parse(JSON.stringify(this.top_sector_list[0]));
              this.stock_details.data = item;

              this.getExpertsListRecommendedForSelectedSector();  //api to get expert list recommeded for sector
            }

            this.ranking_board_sector_name_list = [];

            this.top_sector_list.forEach(element => {
              if (this.ranking_board_sector_name_list.indexOf(element.name) == -1) {
                this.ranking_board_sector_name_list.push(element.name);
              }
            });

            this.sector_rank_board_page_no = response.data.pagination.current_page;
            this.sector_rank_board_number_of_pages = response.data.pagination.total_pages;
            this.sector_rank_board_total_entries = response.data.pagination.total_entries;
            this.is_sector_list_loading = false; //disabled loader
          } else {
            this.top_sector_list = [];
            this.ranking_board_sector_name_list = [];
            this.is_sector_list_loading = false; //disabled loader
            this.is_stocks_details_experts_list_loading = false; //disabled loader
          }
        })
        .catch(
          function (error) {
            console.log(error);
            this.top_sector_list = [];
            this.ranking_board_sector_name_list = [];
            this.is_sector_list_loading = false;  //disabled loader
            this.is_stocks_details_experts_list_loading = false; //disabled loader
          }.bind(this)
        );
    },

    //function to get more stocks for selcted expert
    handleStockDetailsCurrentPageChange(val) {
      this.stock_details_stock_rank_board_page_no = val;
      this.is_stocks_details_experts_list_loading = true; //enabled loader
      this.getExpertsListRecommendedForSelectedSector();
    },

    // api to get selected sector recommeded by experts list
    getExpertsListRecommendedForSelectedSector() {
      serverAddr
        .post("/my_dashboard/v1/sector/flash_card/", {
          user_id: this.userProfile.id,
          duration: this.filterObj.target_period.key
            ? []
            : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
          card_sub_topic: this.expert_details_category,
          sector: this.stock_details.data.name,
          page_number: this.stock_details_stock_rank_board_page_no,
          page_per_entries: this.stock_details_entries_per_page,
          filters: this.filterObj.filters,
          target_period: Object.keys(this.filterObj.target_period).length ? this.filterObj.target_period : {},
          period: !Object.keys(this.filterObj.target_period).length ? this.active_period : ''
        })
        .then(response => {
          if (response.data.status) {
            this.stock_details.experts = [];   //cleared before filling new data

            this.stock_details.experts = response.data.data;
            this.stock_details.data.performer_rating = response.data.overall_rating;

            this.is_stocks_details_experts_list_loading = false; //disabled loader

            this.stock_details_total_entries = response.data.pagination.total_entries;
            this.stock_details_stock_rank_board_number_of_pages = response.data.pagination.total_pages;
            this.stock_details_stock_rank_board_page_no = response.data.pagination.current_page;
          } else {
            this.is_stocks_details_experts_list_loading = false; //disabled loader
            this.stock_details.experts = [];
          }
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_stocks_details_experts_list_loading = false; //disabled loader
            this.stock_details.experts = [];
          }.bind(this)
        );
    },

    //initialize graph
    initGraphInstance() {

      // for success rate chart
      let success_rate_graph_container = this.$refs["success_rate_graph"];
      this.success_rate_graph_instance = echarts.init(
        success_rate_graph_container,
        null,
        this.initOptions
      );

      this.success_rate_graph_instance.on('mouseover', { seriesIndex: 1 }, function (params) {
        this.active_success_rate_inner_chart_legend = params.data.name;    //on chart hovered assigned hovered chart name
        this.active_success_rate_outer_chart_legend = params.data.name;    //on chart hovered assigned hovered chart name

        if (params.seriesIndex) {
          var elem = document.getElementById("success-rate-chart-legends");
          elem.scroll(0, params.dataIndex * 24);
        }

      }.bind(this));

      this.success_rate_graph_instance.on('mouseout', function (params) {
        this.active_success_rate_inner_chart_legend = '';
        this.active_success_rate_outer_chart_legend = '';
      }.bind(this));

      // for portfolio chart
      let portfolio_overview_graph_container = this.$refs["portfolio_overview_graph"];
      this.portfolio_overview_graph_instance = echarts.init(
        portfolio_overview_graph_container,
        null,
        this.initOptions
      );

      this.portfolio_overview_graph_instance.on('mouseover', { seriesIndex: 1 }, function (params) {
        this.active_portfolio_inner_chart_legend = params.data.name;    //on chart hovered assigned hovered chart name
        this.active_portfolio_outer_chart_legend = params.data.name;    //on chart hovered assigned hovered chart name

        if (params.seriesIndex) {
          var elem = document.getElementById("portfolio-chart-legends");
          elem.scroll(0, params.dataIndex * 24);
        }

      }.bind(this));

      this.portfolio_overview_graph_instance.on('mouseout', function (params) {
        this.active_portfolio_inner_chart_legend = '';
        this.active_portfolio_outer_chart_legend = '';
      }.bind(this));

      // for reco count chart
      let reco_count_graph_container = this.$refs["reco_count_graph"];
      this.reco_count_graph_instance = echarts.init(
        reco_count_graph_container,
        null,
        this.initOptions
      );

      this.reco_count_graph_instance.on('mouseover', { seriesIndex: 0 }, function (params) {
        this.active_reco_count_chart_legend = params.data.name;    //on chart hovered assigned hovered chart name
      }.bind(this));

      this.reco_count_graph_instance.on('mouseout', function (params) {
        this.active_reco_count_chart_legend = '';
      }.bind(this));

      // for reco status chart
      let reco_status_graph_container = this.$refs["reco_status_graph"];
      this.reco_status_graph_instance = echarts.init(
        reco_status_graph_container,
        null,
        this.initOptions
      );

      this.reco_status_graph_instance.on('mouseover', { seriesIndex: 0 }, function (params) {
        this.active_reco_status_chart_legend = params.data.name;    //on chart hovered assigned hovered chart name
      }.bind(this));

      this.reco_status_graph_instance.on('mouseout', function (params) {
        this.active_reco_status_chart_legend = '';
      }.bind(this));
    },

    // cleares graph data e.g. x_axis, y_axis, legends
    clearAccuracyGraphData() {
      this.accuracy_pie_chart_series[0].data = [];
      this.accuracy_pie_chart_series[1].data = [];
      // this.horizontal_bar_graph_yaxis_A.data = [];
      // this.horizontal_bar_graph_series_A[0].data = [];
      this.reRenderAccuracyGraphInstance();
    },

    //clears success rate graph data e.g. x_axis, y_axis etc
    clearSuccessRateGraphData() {
      // this.custom_bar_graph_series_xaxis_B.data = [];
      // this.custom_bar_graph_series_B.data = [];
      this.success_rate_pie_chart_series[0].data = [];
      this.success_rate_pie_chart_series[1].data = [];
      this.reRenderSuccessRateGraphInstance();
    },

    clearPortfolioGraphData() {
      this.portfolio_overview_series[0].data = [];
      this.portfolio_overview_series[1].data = [];
      this.reRenderPortfolioOverviewGraphInstance();
    },

    clearMaxRecoGraphData() {
      this.stacked_bar_graph_series = [];
      this.stacked_bar_graph_dataset.source = [];
      this.reRenderMaxRecoGraphInstance();
    },

    //refresh graph instance
    // clearAccuracyGraphInstance: function() {
    //   this.accuracy_graph_instance.clear();
    // },

    //refresh success rate graph instance
    clearSuccessRateGraphInstance: function () {
      this.success_rate_graph_instance.clear();
    },

    // refresh protfolio overview graph instance
    clearPortfolioOverviewGraphInstance: function () {
      this.portfolio_overview_graph_instance.clear();
    },

    clearRecoCountGraphInstance: function () {
      this.reco_count_graph_instance.clear();
    },

    clearRecoStatusGraphInstance: function () {
      this.reco_status_graph_instance.clear();
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderPortfolioOverviewGraphInstance: function () {
      this.clearPortfolioOverviewGraphInstance();
      this.portfolio_overview_graph_instance.setOption(this.protfolidOverviewGraph);
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderRecoCountGraphInstance: function () {
      this.clearRecoCountGraphInstance();
      this.reco_count_graph_instance.setOption(this.recoCountGraph);
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderRecoStatusGraphInstance: function () {
      this.clearRecoStatusGraphInstance();
      this.reco_status_graph_instance.setOption(this.recoStatusPieChart);
    },

    //to trigger changes on graph e.g. to reflect changes data
    // reRenderAccuracyGraphInstance: function() {
    //   this.clearAccuracyGraphInstance();
    //   this.accuracy_graph_instance.setOption(this.accuracyPieChart);
    // },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderSuccessRateGraphInstance: function () {
      this.clearSuccessRateGraphInstance();
      this.success_rate_graph_instance.setOption(this.successRatePieChart);
    },

    //api to get portfolio data
    getProtfolioGraphData() {
      this.is_portfolio_graph_data_available = true;
      this.portfolio_overview_graph_instance.showLoading(this.loader_default); //enabled loader

      serverAddr
        .post("/my_dashboard/v1/sector/market_cap_based_roi", {
          user_id: this.userProfile.id,
          period: this.active_period
        })
        .then(response => {
          if (response.data.status && response.data.data.length) {
            this.clearPortfolioGraphData();

            this.portfolio_overview_graph_instance.hideLoading(this.loader_default); //disabled loader

            for (let i = 0; i < response.data.data.length; i++) {
              // for inner success rate chart - small cap, large cap, mid cap
              if (response.data.data[i].label) {
                let obj = {
                  name: response.data.data[i].label,
                  value: response.data.data[i].weightage,
                  itemStyle: { color: response.data.data[i].label == 'Small Cap' ? '#0d6972' : response.data.data[i].label == 'Mid Cap' ? '#117a93' : response.data.data[i].label == 'Large Cap' ? '#096ad0' : '' },
                  meta_data: response.data.data[i],
                }

                this.portfolio_overview_series[0].data.push(obj);
              }

              for (let j = 0; j < response.data.data[i].sector_data.length; j++) {
                // for outer success rate chart - stock list
                let stock_obj = {
                  name: response.data.data[i].sector_data[j].name,
                  value: response.data.data[i].sector_data[j].weightage,
                  itemStyle: { color: this.chart_colors[this.portfolio_overview_series[1].data.length] },
                  meta_data: response.data.data[i].sector_data[j]
                }

                this.portfolio_overview_series[1].data.push(stock_obj);
              }
            }
          } else {
            this.clearPortfolioGraphData();  //clear graph data e.g. xaxis, yaxis, series

            this.portfolio_overview_graph_instance.hideLoading(this.loader_default); //disabled loader

            this.is_portfolio_graph_data_available = false;
          }

          this.reRenderPortfolioOverviewGraphInstance();
        })
        .catch(function (error) {
          console.log(error);
          this.clearPortfolioGraphData();  //clear graph data e.g. xaxis, yaxis, series

          this.portfolio_overview_graph_instance.hideLoading(this.loader_default); //disabled loader

          this.reRenderPortfolioOverviewGraphInstance();

          this.is_portfolio_graph_data_available = false;
        }.bind(this));
    },

    //api to get accuracy graph data
    getSuccessRateGraphData() {
      this.is_success_rate_graph_data_available = true;
      this.success_rate_graph_instance.showLoading(this.loader_default); //enabled loader

      serverAddr
        .post("/my_dashboard/v1/sector/market_cap_based_success_rate", {
          user_id: this.userProfile.id,
          period: this.active_period
        })
        .then(response => {
          if (response.data.status && response.data.data.length) {
            this.clearSuccessRateGraphData();

            this.success_rate_graph_instance.hideLoading(this.loader_default); //disabled loader

            for (let i = 0; i < response.data.data.length; i++) {
              // for inner success rate chart - small cap, large cap, mid cap
              if (response.data.data[i].label) {
                let obj = {
                  name: response.data.data[i].label,
                  value: response.data.data[i].success_rate,
                  itemStyle: { color: response.data.data[i].label == 'Small Cap' ? '#0d6972' : response.data.data[i].label == 'Mid Cap' ? '#117a93' : response.data.data[i].label == 'Large Cap' ? '#096ad0' : '' }
                }

                this.success_rate_pie_chart_series[0].data.push(obj);
              }

              for (let j = 0; j < response.data.data[i].sector_data.length; j++) {
                // for outer success rate chart - stock list
                let stock_obj = {
                  name: response.data.data[i].sector_data[j].name,
                  value: response.data.data[i].sector_data[j].success_rate,
                  itemStyle: { color: this.chart_colors[this.success_rate_pie_chart_series[1].data.length] }
                }

                this.success_rate_pie_chart_series[1].data.push(stock_obj);
              }
            }
          } else {
            this.clearSuccessRateGraphData();  //clear graph data e.g. xaxis, yaxis, series

            this.success_rate_graph_instance.hideLoading(this.loader_default); //disabled loader

            this.is_success_rate_graph_data_available = false;
          }

          this.reRenderSuccessRateGraphInstance();
        })
        .catch(function (error) {
          console.log(error);
          this.clearSuccessRateGraphData();  //clear graph data e.g. xaxis, yaxis, series

          this.success_rate_graph_instance.hideLoading(this.loader_default); //disabled loader

          this.reRenderSuccessRateGraphInstance();

          this.is_success_rate_graph_data_available = false;
        }.bind(this));

    },

    // api to get recommendation status data
    getRecommendationOverview() {
      this.is_reco_status_data_available = true;
      this.reco_status_graph_instance.showLoading(this.loader_default);     //enabled loader
      this.total_reco = '';

      serverAddr
        .post("/my_dashboard/v1/sector/reco_status_overview", {
          user_id: this.userProfile.id,
          period: this.active_period
        })
        .then(response => {
          if (response.data.status) {
            this.reco_status_pie_chart_series[0].data = [];
            this.reco_status_graph_instance.hideLoading(this.loader_default); //enabled loader

            this.total_reco = response.data.data.total_reco;

            this.reco_status_pie_chart_series[0].data = [
              { value: response.data.data.live_reco, name: 'Live', itemStyle: { color: '#12bce5' } },
              { value: response.data.data.target_achieved, name: 'Target Achieved', itemStyle: { color: '#b6d094' } },
              { value: response.data.data.target_not_achieved, name: 'Target Not Achieved', itemStyle: { color: '#d60918' } },
              { value: response.data.data.stop_loss_triggered, name: 'Stop Loss Triggered', itemStyle: { color: '#fcaa8e' } },
            ]

          } else {
            this.is_reco_status_data_available = false;
            this.total_reco = '';
            this.reco_status_pie_chart_series[0].data = [];
            this.reco_status_graph_instance.hideLoading(this.loader_default);     //disabled loader
          }

          this.reRenderRecoStatusGraphInstance();
        })
        .catch(function (error) {
          console.log(error);
          this.is_reco_status_data_available = false;
          this.total_reco = '';
          this.reco_status_pie_chart_series[0].data = [];
          this.reco_status_graph_instance.hideLoading(this.loader_default);     //disabled loader
          this.reRenderRecoStatusGraphInstance();
        }.bind(this));
    },

    // api to get recommendation count data
    getRecommendationCount() {
      this.is_reco_count_data_available = true;
      this.reco_count_graph_instance.showLoading(this.loader_default); //enabled loader

      serverAddr
        .post("/my_dashboard/v1/sector/period_based_roi", {
          user_id: this.userProfile.id,
          period: this.active_period
        })
        .then(response => {
          if (response.data.status && response.data.data.length) {
            this.reco_count_series[0].data = [];
            this.reco_count_graph_instance.hideLoading(this.loader_default); //disabled loader

            for (let i = 0; i < response.data.data.length; i++) {
              if (response.data.data[i].term == 'Short term') {
                let obj = { value: response.data.data[i].total_reco, name: 'Short Term', itemStyle: { color: '#d3d3d3' }, meta_data: response.data.data[i].absolute_roi };
                this.reco_count_series[0].data.push(obj);
              }

              if (response.data.data[i].term == 'Long term') {
                let obj = { value: response.data.data[i].total_reco, name: 'Long Term', itemStyle: { color: '#565656' }, meta_data: response.data.data[i].absolute_roi };
                this.reco_count_series[0].data.push(obj);
              }
            }

          } else {
            this.is_reco_count_data_available = false;
            this.total_reco = '';
            this.reco_count_series[0].data = [];
            this.reco_count_graph_instance.hideLoading(this.loader_default);     //disabled loader
          }

          this.reRenderRecoCountGraphInstance();
        })
        .catch(function (error) {
          console.log(error);
          this.total_reco = '';
          this.is_reco_count_data_available = false;
          this.reco_count_series[0].data = [];
          this.reco_count_graph_instance.hideLoading(this.loader_default);     //disabled loader
          this.reRenderRecoCountGraphInstance();
        }.bind(this));
    },

    //api to get accuracy graph data
    getAccuracyGraphData() {
      this.is_accuracy_graph_data_available = true;
      this.accuracy_graph_instance.showLoading(this.loader_default); //enabled loader

      serverAddr
        .post("/my_dashboard/v1/sector/market_cap_based_accuracy", {
          user_id: this.userProfile.id,
          period: this.active_period
        })
        .then(response => {
          if (response.data.status && response.data.data.length) {
            this.clearAccuracyGraphData();

            this.accuracy_graph_instance.hideLoading(this.loader_default); //disabled loader

            for (let i = 0; i < response.data.data.length; i++) {
              // for inner success rate chart - small cap, large cap, mid cap
              if (response.data.data[i].label) {
                let obj = {
                  name: response.data.data[i].label,
                  value: response.data.data[i].avg_accuracy,
                  itemStyle: { color: response.data.data[i].label == 'Small Cap' ? '#0d6972' : response.data.data[i].label == 'Mid Cap' ? '#117a93' : response.data.data[i].label == 'Large Cap' ? '#096ad0' : '' }
                }

                this.accuracy_pie_chart_series[0].data.push(obj);
              }

              for (let j = 0; j < response.data.data[i].sector_data.length; j++) {
                // for outer success rate chart - stock list
                let stock_obj = {
                  name: response.data.data[i].sector_data[j].name,
                  value: response.data.data[i].sector_data[j].avg_accuracy,
                  itemStyle: { color: this.chart_colors[this.accuracy_pie_chart_series[1].data.length] }
                }

                this.accuracy_pie_chart_series[1].data.push(stock_obj);
              }
            }
          } else {
            this.clearAccuracyGraphData();  //clear graph data e.g. xaxis, yaxis, series

            this.accuracy_graph_instance.hideLoading(this.loader_default); //disabled loader

            this.is_accuracy_graph_data_available = false;
          }

          this.reRenderAccuracyGraphInstance();
        })
        .catch(function (error) {
          console.log(error);
          this.clearAccuracyGraphData();  //clear graph data e.g. xaxis, yaxis, series

          this.accuracy_graph_instance.hideLoading(this.loader_default); //disabled loader

          this.reRenderAccuracyGraphInstance();

          this.is_accuracy_graph_data_available = false;
        }.bind(this));
    },

    //api to get badge details
    getBadgeProfile() {
      this.is_profile_data_loading = true;   //enable loading

      serverAddr
        .post("stockants_pro/overall-ranking-user/", {
          filters: this.filterObj.filters,
          sector: this.filterObj.sector,
          expert_id_list: [this.userProfile.id],
          ranking_by: this.active_sector_ranking_sorting,
          duration: this.filterObj.target_period.key
            ? []
            : ["IntraDay", "Week", "Month", "Quarter", "Long_term"],
          target_period: Object.keys(this.filterObj.target_period).length ? this.filterObj.target_period : {},
          period: !Object.keys(this.filterObj.target_period).length ? this.active_period : ''
        })
        .then((response) => {
          if (response.data.status) {
            this.is_profile_data_loading = false;
            if (response.data.data.length) {
              this.badge_profile.rank = response.data.data[0].rank;
              this.badge_profile.total_expert_count = response.data.data[0].total_expert_count;
            } else {
              this.badge_profile = { rank: '', total_expert_count: '' };
            }
          } else {
            this.badge_profile = { rank: '', total_expert_count: '' };
            this.is_profile_data_loading = false;
          }
        })
        .catch(
          function (error) {
            console.log(error);
            this.badge_profile = { rank: '', total_expert_count: '' };
            this.is_profile_data_loading = false;
          }.bind(this)
        );
    },
  },

  computed: {
    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },
}
</script>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.UserDashboardTopSectors .flex-space-between {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.UserDashboardTopSectors .rank-board-table {
  overflow-x: auto;
  border-spacing: 0;
  border-collapse: collapse;

  .border-right-gray {
    border-right: 1px solid #e9e9e9;
  }

  .border-bottom-gray {
    border-bottom: 1px solid #e9e9e9;
  }

  .bottom-spacing-table-heading {
    padding: 0px 8px 8px 8px;
  }

  width: 100%;

  thead {
    tr {
      th {
        color: #a5a6a8;
        font-size: 13px;
        font-weight: 600;
        padding: 0 5px 5px 5px;
      }
    }

    tr:nth-child(2) {
      border-bottom: 1px solid #e9e9e9;
    }
  }

  tbody {
    tr {
      cursor: pointer;

      td {
        font-size: 12px;
        font-weight: 600;
        text-align: center;
        padding: 15px 10px;
        height: 50px;
      }
    }

    tr:hover {
      background-color: #eff5fe;
    }

    .selected-row {
      background-color: #eff5fe;
    }
  }
}

.UserDashboardTopSectors .stock-detail-card {
  margin: 10px 0px;
  min-height: 423px;
  border-radius: 10px;
}

.UserDashboardTopSectors .stock-base-details {
  background-color: #eff5fe;
  padding: 15px;

  .stock-base-header {
    display: flex;
    width: 100%;
    align-items: center;
  }

  .role-rating-wrapper {
    display: flex;
    align-items: center;

    label {
      font-size: 11px;
      font-weight: 500;
      margin-right: 10px;
    }
  }
}

.stock-accuracy-detail-wrapper {
  padding: 15px;
  min-height: 150px;

  table {
    width: 100%;

    thead {
      th:nth-child(1) {
        text-align: left;
      }

      th {
        font-size: 11px;
        font-weight: 500;
        color: #a5a6a8;
        text-align: center;
        padding: 5px 0 0 0;
      }
    }

    tbody {
      td:nth-child(1) {
        text-align: left;

        div {
          display: flex;
          align-items: center;
          font-size: 10px;
          margin-top: 1px;
        }
      }

      td {
        font-weight: 500;
        text-align: center;
        padding: 5px 0;
      }
    }
  }

  .more-wrapper-btn-section {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .expand_more_wrappers_btn {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 50px;
    height: 20px;
    width: 20px;
    margin: 0px 0px;
    text-align: center;

    .el-icon-arrow-down {
      color: #a5a6a8;
      font-size: 10px;
    }
  }

  .faded-border {
    display: block;
    border: none;
    color: #fff;
    height: 1px;
    background: -webkit-gradient(radial, 50% 50%, 0, 50% 50%, 80, from(#ddd), to(#fff));
  }
}

.badge-profile-card {
  background: #f5f8fc;

  .el-card__body {
    padding: 0;
  }

  .badge-bg {
    background-image: url('../assets/images/blue_asset_user_dashboard.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    // background: #2d2e8d;
    position: relative;
    // background: linear-gradient(
    //   90deg,
    //   #2d2e8d 0%,
    //   #3f49bc 25%,
    //   #4c5bdd 50%,
    //   #3f49bc 75%,
    //   #2d2e8d 100%
    // );
    width: 100%;
    height: 100px;
    // box-sizing: border-box;
    // border-bottom-left-radius: 50%;
    // border-bottom-right-radius: 50%;
  }

  .badge-img-section {
    display: inline-block;
    text-align: center;
    top: 45px;
    position: absolute;
    left: 0;
    right: 0;

    img {
      width: 115px;
    }
  }

  .ranking_number {
    position: absolute;
    top: 45px;
    right: 0;
    left: 0;
    color: #fff;
    // color: #7b6614;
    font-weight: 600;
    font-size: 12px;
  }

  .badge-body {
    padding: 10px;
    margin-top: 65px;

    .badge-details-table {
      width: 100%;
      text-align: center;

      thead th {
        font-size: 12px;
        color: #000;
      }

      tbody td {
        font-size: 12px;
        color: #979797;
      }
    }
  }

  .badge-primary-text {
    font-size: 13px;
    font-weight: bold;
    text-align: center;
  }
}

@media screen and (max-width: 900px) {
  .UserDashboardTopSectors .rank-board-table {
    display: block;
  }
}

@media screen and (max-width: 1200px) {
  .UserDashboardTopSectors .rank-board-table {

    // display: block;
    th {
      width: 110px;
    }
  }

  .badge-profile-card {
    max-width: 500px;
    margin: 0 auto;

    .badge-bg {
      height: 125px;
    }

    .badge-img-section {
      top: 70px;
    }
  }
}

@media screen and (max-width: 575px) {
  .UserDashboardTopSectors .stock-detail-card {
    margin: 5px !important;
  }

  .UserDashboardTopSectors .stock-accuracy-detail-wrapper {
    padding: 20px 10px;
  }
}</style>
<style lang="scss">@import "../css/variable.scss";
@import "../css/common.scss";

.UserDashboardTopSectors .box-card {
  border-radius: 10px !important;
  border: none;
  box-shadow: none;
}

.UserDashboardTopSectors .expert-card {
  min-height: 450px;
}

.UserDashboardTopSectors .expert-card .el-card__body {
  padding: 20px 0;
}

.UserDashboardTopSectors .stock-detail-card .el-card__body {
  padding: 0px 0;
}

.UserDashboardTopSectors .NoDataFound {
  padding: 60px 0 0 0;
}

.UserDashboardTopSectors .el-icon-download,
.el-icon-share {
  margin: 0 12px;
}

.UserDashboardTopSectors .el-rate__icon {
  margin-right: 0px !important;
  font-size: 14px !important;
}

.UserDashboardTopSectors .el-pager li.active {
  color: #3f67f2;
}

.UserDashboardTopSectors .el-loading-mask {
  z-index: 1;
}

.UserDashboardTopSectors .role-rating-wrapper .el-rate__icon {
  font-size: 10px !important;
}

.el-tooltip__popper {
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600 !important;
}

.stock-ranking,
.sector-ranking {
  .no-data-container {
    max-width: 225px !important;
  }
}</style>
